import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBooking } from "../../context/BookingContext";
import styles from "./PaymentSuccess.module.css";
import { verifyPayment } from "../../api/api";
import useAuthGuard from "../../hooks/useAuthGuard";

const PaymentSuccess = () => {
  useAuthGuard();
  const location = useLocation();
  const navigate = useNavigate();
  const { setBookings } = useBooking();
  const [message, setMessage] = useState("Verifying...");
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    setBookings([]);
    localStorage.removeItem("bookings");

    const query = new URLSearchParams(location.search);
    const freeBooking = query.get("freeBooking");
    const cartId = query.get("cart_id");
    const status = query.get("status");

    if (freeBooking === "1") {
      setMessage("Your booking has been completed successfully.");
      setIsChecking(false);
      return;
    }

    if (!cartId) {
      setTimeout(() => {
        setMessage("Missing payment information. Please try again.");
        setIsChecking(false);
      }, 5000);
      return;
    }

    verifyPayment(cartId)
      .then((response) => {
        console.log("Verification response:", response.data);
        if (
          response.data.message &&
          response.data.message.includes("Payment successful")
        ) {
          setMessage(
            "Your payment was successful. Your booking is now confirmed."
          );
        } else {
          setMessage("Payment verification failed or payment not successful.");
        }
      })
      .catch((error) => {
        console.error("Error verifying payment:", error);
        setMessage(
          "There was an error verifying your payment. Please contact support."
        );
      })
      .finally(() => setIsChecking(false));
  }, [location.search, setBookings]);

  return (
    <div className={styles.container}>
      <h2>{message}</h2>
      {!isChecking && (
        <button onClick={() => navigate("/dashboard")}>
          Back to Home
        </button>
      )}
    </div>
  );
};

export default PaymentSuccess;